import { FunctionComponent } from "react";
import BannerKountries from "@Components/molecules/BannerKountries";
import Category from "@Components/organisms/Category";
import Footer from "@Components/organisms/Footer";
import Header from "@Components/organisms/Header";

interface Props {
  categoryTag: string;
}

const CategoryPage: FunctionComponent<Props> = ({ categoryTag }) => {
  return (
    <>
      <BannerKountries />
      <Header />
      <Category categoryTag={categoryTag} />
      <Footer />
    </>
  );
};

export default CategoryPage;
